<template>
  <div class="card-section">
    <div v-for="(card, index) in contentList" :key="index" class="card-item">
      <img :src="card.imag" alt="" @click="handleJump(card)" />
    </div>
    <van-popup v-model="show">{{ showText }}</van-popup>
  </div>
</template>

<script>
import { MODULE_STATUS } from './constant'
import { Popup } from 'vant'

export default {
  name: 'TwoCard',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    content: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      MODULE_STATUS,
      show: false,
      showText: '',
    }
  },
  computed: {
    config() {
      return this.$props.content[0]
    },
    contentList() {
      return this.config?.cardInfoList || []
    },
  },
  methods: {
    /** 处理跳转 */
    handleJump(item) {
      this.showText = item.appletLink
      this.show = true
    },
  },
}
</script>

<style lang="less" scoped>
.card-section {
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 32px 18px;
  border-radius: 40px 40px 0 0;

  /deep/ .van-popup {
    background: transparent;
    color: #fff;
  }

  .card-item {
    flex: 1;
    margin-right: 26px;
    height: 130px;

    &:last-child {
      margin-right: 0;
    }

    img {
      display: block;
      border-radius: 6px;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
